import { Button } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

import './styles/index.css';

const MobileModalDetails = ({ isModalDetailsOpen, handleClick, content }) => {
  const unavailableSymbol = '--';
  const getField = (label, value) => (
    <div className="mobile-details-modal__content--field" key={label}>
      <span>{label}</span>
      <p>{value || unavailableSymbol}</p>
    </div>
  );

  return (
    <div className={`mobile-details-modal ${isModalDetailsOpen ? 'mobile-details-modal__open' : ''}`}>
      {isModalDetailsOpen && (
        <div className="mobile-details-modal__wrapper">
          <div className="mobile-details-modal__closebtn">
            <Button handleClick={handleClick}>
              <CustomIcon type="mdclose" size="32" />
            </Button>
          </div>
          <div className="mobile-details-modal__content">
            {content &&
              content.map(data => {
                const { label, value, secondField = {} } = data;
                if (Object.keys(secondField).length) {
                  const { label: labSecField, value: valSecField } = secondField;
                  return (
                    <div className="mobile-details-modal__content--2col" key={label}>
                      {getField(label, value)}
                      {getField(labSecField, valSecField)}
                    </div>
                  );
                }
                return getField(label, value);
              })}
          </div>
        </div>
      )}
    </div>
  );
};

MobileModalDetails.propTypes = {
  isModalDetailsOpen: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  content: PropTypes.instanceOf(Array).isRequired
};

export default MobileModalDetails;
